import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'generateDates'
})
export class GenerateDatesPipe implements PipeTransform {

  transform(dates: any, long: boolean, args?: any): any {

    if(dates.length > 0){

      //order dates to 1,2,3,4,5,6,0
      dates.sort();
      //make first element to last
      

      if(!long){
        for (let i = 0; i < dates.length; i++) {
          const date = dates[i];
          
          switch (date) {
            case 1:
              dates[i] = 'Ma'
              break;
            case 2:
              dates[i] = 'Ti'
              break;
            case 3:
              dates[i] = 'Ke'
              break;
            case 4:
              dates[i] = 'To'
              break;
            case 5:
              dates[i] = 'Pe'
              break;
            case 6:
              dates[i] = 'La'
              break;
            case 0:
              dates[i] = 'Su'
              break;
              
            default:
              break;
          }
        }
        return dates.join(', ');
      }
      else{
        for (let i = 0; i < dates.length; i++) {
          const date = dates[i];
          
          switch (date) {
            case 1:
              dates[i] = 'maanantai'
              break;
            case 2:
              dates[i] = 'tiistai'
              break;
            case 3:
              dates[i] = 'keskiviikko'
              break;
            case 4:
              dates[i] = 'torstai'
              break;
            case 5:
              dates[i] = 'perjantai'
              break;
            case 6:
              dates[i] = 'lauantai'
              break;
            case 0:
              dates[i] = 'sunnuntai'
              break;
              
            default:
              break;
          }
        }
        //If sunnuntai is first element move it to last
        if(dates[0] == 'sunnuntai'){
          var first = dates.shift();
          dates.push(first);
        }
        return dates.join(', ');
      }
    }
  }

}
